import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from '../../providers/dto/location';
import { Bin } from '../../providers/dto/bin';
import { NavController } from 'ionic-angular';
import { Article } from '../dto/article';
import { InventoryResult } from '../dto/stock';
import { StockProvider } from '../stock/stock';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the InventoryLogicProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InventoryLogicProvider {

  public location: Location;
  public bin: Bin[];
  public selectedBin : Bin;

  public resetData() {
    this.location = undefined;
    this.bin = undefined;
    this.selectedBin = undefined;
  }

  constructor(public http: HttpClient, private stockProvider: StockProvider) {
    console.log('Hello InventoryLogicProvider Provider');
  }

  public getNextPage(pStartPage: string): string {
    if(pStartPage === "InventoryScanLocationOrBinPage") {
      if(this.location != undefined && (this.bin == undefined || this.bin.length !== 1)) {
        return "InventoryScanBinPage";
      }
      if(this.location != undefined && this.bin != undefined && this.bin.length === 1) {
        this.selectedBin = this.bin[0];
        return "InventoryArticleAndQuantityPage";
      }
      return "";
    }

    if(pStartPage === "InventoryScanBinPage") {
      if(this.location != undefined && this.bin != undefined && this.selectedBin != undefined) {
        
        return "InventoryArticleAndQuantityPage";
      }
    }

    if(pStartPage === "InventoryArticleAndQuantityPage") {
      this.resetData();
      return "InventoryScanLocationOrBinPage";
    }
  }

  /**
   * Navigates to next page and removes current page from stack at same time.
   * @param pPage 
   */
  public navigateToNextPage(navCtrl: NavController, pPage: string, pParams: any) {
    navCtrl.push(pPage, pParams).then(() => {
      // first we find the index of the current view:
      const startIndex = navCtrl.getActive().index - 1;
      // then we remove it from the navigation stack
      navCtrl.remove(startIndex);
    });
  }

  public postCountResult(pItems: ArticleAndQuanityItem[]) {
    let res : InventoryResult = new InventoryResult();
    res.binId = this.selectedBin.id;
    res.stocks = [];
    for(var o of pItems) {
      res.stocks.push({articleId: o.article.id, quantity: o.quantity});
    }

    return this.stockProvider.bookInventoryResult(res);
  }
}


export class ArticleAndQuanityItem {
  public constructor () {
    this.number = "";
    this.quantity = 0;
  };
  public id : number;
  public number : string;
  public name : string;
  public unit : string;
  public quantity : number;
  public article : Article;
}


// WEBPACK FOOTER //
// ./src/providers/inventory-logic/inventory-logic.ts